import { createFileRoute } from '@tanstack/react-router';
import DistributorCreatePage from '../views/distributor';

export const Route = createFileRoute('/d/$path')({
  component: DistributorCreatePage,
});
